import { graphql } from 'gql';

export const catalogRatiosGql = graphql(`
    query catalogRatios(
        $order: [CatalogRatioDataForListSortInput!]
        $skip: Int
        $take: Int
        $where: CatalogRatioDataForListFilterInput
    ) {
        catalogRatios(order: $order, skip: $skip, take: $take, where: $where) {
            items {
                id
                code
                hasCosts
                name
                catalogRatioGroupId
                catalogRatioGroupName
                updatedAt
                ratioType
                kmat
                ktz
                ktzzpm
                kozp
                knr
                ksp
                kem
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosGroupFilterGql = graphql(`
    query catalogRatioGroupFilter(
        $order: [FilterValueOfStringSortInput!]
        $skip: Int
        $where: FilterValueOfStringFilterInput
    ) {
        catalogRatioGroupFilter(order: $order, skip: $skip, take: 1000, where: $where) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosCodeFilterGql = graphql(`
    query catalogRatioCodeFilter(
        $order: [FilterValueOfStringSortInput!]
        $skip: Int
        $where: FilterValueOfStringFilterInput
    ) {
        catalogRatioCodeFilter(order: $order, skip: $skip, take: 1000, where: $where) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const catalogRatiosTypeFilterGql = graphql(`
    query catalogRatioTypeFilter {
        catalogRatioTypeFilter {
            items {
                value
            }
            totalCount
        }
    }
`);

export const catalogRatiosNameFilterGql = graphql(`
    query catalogRatioNameFilter(
        $order: [FilterValueOfStringSortInput!]
        $skip: Int
        $where: FilterValueOfStringFilterInput
    ) {
        catalogRatioNameFilter(order: $order, skip: $skip, take: 1000, where: $where) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const removeCatalogRatioGql = graphql(`
    mutation removeCatalogRatio($catalogRatioId: Long!) {
        removeCatalogRatio(catalogRatioId: $catalogRatioId) {
            result
            message
            id
        }
    }
`);
